<template>
  <div
    :class="[
      'd-flex',
      'flex-column',
      'custom-container',
      'align-items-center',
      headerConfig.showProgress
        ? 'justify-content-between'
        : 'justify-content-center'
    ]"
  >
    <div v-if="headerConfig.showProgress" class="header border-bottom">
      <transition name="fade" mode="out-in">
        <div class="progresso">
          <div class="progresso-topo">
            <h3 class="text-uppercase fw-bold">
              {{ titleProgress }}
            </h3>
            <span class="progresso-indicador">
              {{ progressLabel }}
            </span>
          </div>
          <div class="progress-bar">
            <b-progress
              striped
              animated
              height="12px"
              variant="success"
              :value="headerConfig.progress.percent"
            />
          </div>
        </div>
      </transition>
    </div>

    <component
      v-bind="activeProps"
      ref="activeContainer"
      :is="activeComponent"
      v-if="activeComponent"
      @completed="handleCompleted"
      :footer-action="footerAction"
      @footer-change="handleFooterChange"
      @header-change="handleHeaderChange"
    />

    <div v-if="footerConfig.show" :class="[acoesFooter, 'border-top']">
      <b-button
        v-for="action in footerVisiveis"
        :key="action.id"
        :variant="action.variant"
        :disabled="action.disabled"
        @click="handleFooterAction(action.id)"
        :class="[
          action.class,
          'font-size-14',
          'button-footer',
          'justify-content-center',
          'd-flex align-items-center'
        ]"
      >
        <b-spinner v-if="action.loading" class="custom-spinner" />
        <div
          v-else
          :class="[
            'd-flex',
            'gap-2',
            'align-items-center',
            'justify-content-center'
          ]"
        >
          <span class="font-size-16 fw-normal text-button">{{
            action.label
          }}</span>
          <i :class="['font-size-18 mdi', action.icon]"></i>
        </div>
      </b-button>
    </div>
  </div>
</template>

<script lang="js">
import { campanhaRegistryService } from "../services/campanhaRegistryService";

export default {
  name: "GlobalCampanhaPanel",
  props: {
    campaignId: {
      type: String,
      default: "acompanhamento-mensal"
    },
    campaignContext: {
      type: Object,
      default: () => ({})
    },
    titleProgress: {
      type: String,
      default: "Progresso do formulário"
    }
  },

  data() {
    return {
      activeCampaign: null,
      headerConfig: {
        showProgress: false,
        progress: {
          current: 0,
          total: 0,
          percent: 0
        }
      },
      footerConfig: {
        show: false,
        actions: []
      },
      footerAction: ""
    };
  },

  computed: {
    activeComponent() {
      return this.activeCampaign?.componentRef || null;
    },

    activeProps() {
      return this.activeCampaign?.props || {};
    },

    cdPessoa() {
      return this.$store?.state?.me?.cd_pessoa || null;
    },

    footerVisiveis() {
      return (this.footerConfig.actions || []).filter(
        action => action.visible !== false
      );
    },

    progressLabel() {
      return '';
    },

    acoesFooter() {
      const firstAction = this.footerConfig.actions[0];
      const isFirstActionIsStart = firstAction?.id === "back";
      return isFirstActionIsStart ? "acoes-footer-buttons" : "acoes-footer";
    }
  },

  methods: {
    abrirCampanha(campaignId, context = {}) {
      const campaignConfig = campanhaRegistryService.getCampaignConfig(
        campaignId,
        context
      );

      if (!campaignConfig) {
        return;
      }

      this.resetModalState();
      this.activeCampaign = campaignConfig;
    },

    handleCompleted(dados) {
      this.$root.$emit("campanha:respostas-enviadas", dados);
    },

    handleHeaderChange(headerConfig) {
      this.headerConfig = {
        ...this.headerConfig,
        ...headerConfig,
        progress: {
          ...this.headerConfig.progress,
          ...(headerConfig?.progress || {})
        }
      };
    },

    handleFooterChange(footerConfig) {
      this.footerConfig = {
        show: Boolean(footerConfig?.show),
        actions: Array.isArray(footerConfig?.actions)
          ? footerConfig.actions
          : []
      };
    },

    handleFooterAction(actionId) {
      this.footerAction = actionId;

      this.$nextTick(() => {
        this.footerAction = "";
      });
    },

    resetModalState() {
      this.headerConfig = {
        titulo: "",
        showProgress: false,
        progress: {
          current: 0,
          total: 0,
          percent: 0
        }
      };
      this.footerConfig = {
        show: false,
        actions: []
      };
      this.footerAction = "";
      this.activeCampaign = null;
    }
  },

  created() {
    this.abrirCampanha(this.campaignId, {
      cdPessoa: this.cdPessoa,
      ...this.campaignContext
    });
  }
};
</script>

<style lang="scss" scoped>
.custom-container {
  min-height: 70svh;
}

.header {
  width: 100%;
  padding: 1.25rem;
}

.progresso-topo {
  display: flex;
  font-size: 13px;
  margin-bottom: 5px;
  align-items: center;
  justify-content: space-between;
}

.progresso-topo h3 {
  margin: 0;
  font-size: 16px;
  color: #13345a;
}

.progresso-indicador {
  color: #0d9b49;
  font-weight: 700;
}

.progress-bar {
  width: 100%;
  border-radius: 0.25rem;
  background-color: #f6f6f6;
}

.acoes-footer {
  gap: 12px;
  width: 100%;
  display: flex;
  padding: 1.25rem;
  justify-content: flex-end;
}

.acoes-footer-buttons {
  gap: 12px;
  width: 100%;
  display: flex;
  padding: 1.25rem;
  justify-content: space-between;
}

.button-footer {
  min-width: 190px;
  min-height: 45px;
}

.custom-spinner {
  height: 20px;
  width: 20px;
}

@media (max-width: 576px) {
  .header-conatiner {
    display: grid !important;
    grid-template-columns: 1fr auto;
  }

  .acoes-footer {
    flex-direction: column;
  }

  .button-footer {
    width: 100%;
    padding: 5px;
    min-width: auto;
    min-height: auto;
  }

  .text-button {
    font-size: 13px !important;
  }

  .progresso-topo h3 {
    font-size: 14px;
  }
}
</style>
